import * as React from 'react'

import { Box, Button, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'

export interface ItemProps {
  onClick: () => void
  show: boolean
  label: string
}
export interface ActionProps {
  onClick: () => void
  show: boolean
  label: string
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
}

export interface EllipsisProps {
  show: boolean
  options: Option[]
}

interface Props {
  action?: ActionProps
  settings?: ItemProps
  ellipsis?: EllipsisProps
}

const defaultItemProps = {
  show: false,
  onClick: () => {},
  label: '',
}

const defaultItemEllipsisProps = { ...defaultItemProps, options: [] }

const RightAction = ({
  action = defaultItemProps,
  settings = defaultItemProps,
  ellipsis = defaultItemEllipsisProps,
}: Props) => {
  const [open, toggle] = useToggle(false)

  if (!settings.show && !action.show && !ellipsis.show) {
    return null
  }

  const onClickAction = () => {
    action.onClick()
  }

  const onClickSettings = () => {
    settings.onClick()
  }

  return (
    <Box gap="s4" flexDirection="row">
      {action.show && (
        <Button onClick={onClickAction} type="primary" iconName={action.icon || 'add'}>
          {action.label}
        </Button>
      )}
      {settings.show && (
        <Tooltip.Alt
          attachment="top center"
          targetAttachment="bottom center"
          open={open}
          toggle={toggle}
          label={settings.label}
        >
          <Button onClick={onClickSettings} type="primary" iconName="settings" />
        </Tooltip.Alt>
      )}
      {!settings.show && ellipsis.show && (
        <Popover
          attachment="top right"
          targetAttachment="bottom center"
          open={open}
          toggle={toggle}
        >
          <Button type="primary" onClick={toggle(true)} iconName="ellipsis" />
          <PopoverContent onClose={toggle(false)} options={ellipsis.options} />
        </Popover>
      )}
    </Box>
  )
}

export default RightAction
